module.exports = __webpack_public_path__ + "static/media/fokusMobile.1a28ce47.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/media/images/fokusMobile.jpg
// module id = 850
// module chunks = 7